<template>
    <div class="designers">
        <Fold />

        <div class="container">
            <div class="gr-12">
                <section class="team">
                    <ul class="team__list">
                        <li class="team__item">
                            <div class="card card--01">
                                <header class="card__header">
                                    <h3 class="card__title">Ivica Mamić</h3>
                                    <div class="card__social">
                                        <a href="#" target="_blank">
                                            <svgicon icon="linkedin"></svgicon>
                                        </a>
                                    </div>
                                </header>
                                <figure class="card__figure">
                                    <img src="@/assets/team/ivica-mamic.jpg" alt="" class="rspimg">
                                </figure>
                                <div class="card__data">
                                    <h3 class="card__position">Director / Designer</h3>
                                    <a href="mailto:" class="card__email">ivica@dizviz.hr</a>
                                </div>
                            </div>
                        </li>

                        <li class="team__item">
                            <div class="card card--01">
                                <header class="card__header">
                                    <h3 class="card__title">Vedrana Škalić</h3>
                                    <div class="card__social">
                                        <a href="#" target="_blank">
                                            <svgicon icon="linkedin"></svgicon>
                                        </a>
                                    </div>
                                </header>
                                <figure class="card__figure">
                                    <img src="@/assets/team/vedrana-skalic.jpg" alt="" class="rspimg">
                                </figure>
                                <div class="card__data">
                                    <h3 class="card__position">Designer</h3>
                                    <a href="mailto:" class="card__email">vedrana@dizviz.hr</a>
                                </div>
                            </div>
                        </li>

                        <li class="team__item">
                            <div class="card card--01">
                                <header class="card__header">
                                    <h3 class="card__title">Saša Poslončec</h3>
                                    <div class="card__social">
                                        <a href="#" target="_blank">
                                            <svgicon icon="linkedin"></svgicon>
                                        </a>
                                    </div>
                                </header>
                                <figure class="card__figure">
                                    <img src="@/assets/team/sasa-posloncec.jpg" alt="" class="rspimg">
                                </figure>
                                <div class="card__data">
                                    <h3 class="card__position">Designer</h3>
                                    <a href="mailto:" class="card__email">sasa@dizviz.hr</a>
                                </div>
                            </div>
                        </li>
                    </ul>
                </section>
            </div>


            <div class="gr-12">
                <section class="team">
                    <h3 class="heading heading--small">Others</h3>

                    <ul class="team__list">
                        <li class="team__item">
                            <div class="card card--02">
                                <header class="card__header">
                                    <h3 class="card__title">Johnsie Ziolkowski</h3>
                                    <div class="card__social">
                                        <a href="#" target="_blank">
                                            <svgicon icon="linkedin"></svgicon>
                                        </a>
                                    </div>
                                </header>
                                <div class="card__data">
                                    <h3 class="card__position">Designer</h3>
                                    <a href="mailto:" class="card__email">johnsie@dizviz.hr</a>
                                </div>
                            </div>
                        </li>

                        <li class="team__item">
                            <div class="card card--02">
                                <header class="card__header">
                                    <h3 class="card__title">Samira Duffy</h3>
                                    <div class="card__social">
                                        <a href="#" target="_blank">
                                            <svgicon icon="linkedin"></svgicon>
                                        </a>
                                    </div>
                                </header>
                                <div class="card__data">
                                    <h3 class="card__position">Designer</h3>
                                    <a href="mailto:" class="card__email">samira@dizviz.hr</a>
                                </div>
                            </div>
                        </li>

                        <li class="team__item">
                            <div class="card card--02">
                                <header class="card__header">
                                    <h3 class="card__title">Cristobal Peachey</h3>
                                    <div class="card__social">
                                        <a href="#" target="_blank">
                                            <svgicon icon="linkedin"></svgicon>
                                        </a>
                                    </div>
                                </header>
                                <div class="card__data">
                                    <h3 class="card__position">Designer</h3>
                                    <a href="mailto:" class="card__email">cristobal@dizviz.hr</a>
                                </div>
                            </div>
                        </li>
                    </ul>
                </section>
            </div>
        </div>

        <div class="container">
            <div class="gr-12">
                <Gallery />
            </div>
        </div>


        <Prefooter />
        <Footer />
    </div>
</template>


<script>

// components
import Fold from '@/components/Fold.vue';
import Gallery from '@/components/Gallery.vue';
import Prefooter from '@/components/Prefooter.vue';
import Footer from '@/components/Footer.vue';

//import icons
import '@/compiled-icons/linkedin';


export default {
    name: 'designers',
    components: {
        Fold,
        Gallery,
        Prefooter,
        Footer
    },

    data() {
        return {}
    },

    methods: {
        toggleBodyClass(addRemoveClass, className) {
            const el = document.body;

            if (addRemoveClass === 'addClass') {
                el.classList.add(className);
            } else {
                el.classList.remove(className);
            }
        },

    },

    mounted() {
        this.toggleBodyClass('addClass', 'page-designers');
    },

    destroyed() {
        this.toggleBodyClass('removeClass', 'page-designers');
    }
};
</script>


<style scoped lang="scss">

</style>